module.exports = __webpack_public_path__ + "img/edit.a0840adc.svg";